module.exports = __webpack_public_path__ + "img/diangugushi-1@3x.68363b56.png";